<template>
  <fh-container>
    <fh-title>Cambiar Pin</fh-title>

    <fh-card>
      <v-form ref="form" v-model="valid" lazy-validation>

        <!-- Username -->
        <!-- Hidden field to make browser pin manager work correctly -->
        <v-text-field
          v-show="false"
          label="Cuenta"
          v-model="codigoAcceso"
          autocomplete="username"
        ></v-text-field>

        <!-- Current Pin -->
        <v-text-field
          autofocus
          :rules="currentPinRules"
          @keyup.enter="handleChangePin"
          label="Pin actual"
          type="password"
          inputmode="numeric"
          v-model="currentPin"
          autocomplete="current-password"
        ></v-text-field>

        <div class="my-2 py-3"></div>

        <!-- New Pin -->
        <v-text-field
          :rules="newPinRules"
          @keyup.enter="handleChangePin"
          @input="validatePin"
          label="Pin nuevo"
          type="password"
          inputmode="numeric"
          v-model="newPin"
          autocomplete="new-password"
        ></v-text-field>

        <!-- New Pin 2 -->
        <v-text-field
          :rules="newPinRules2"
          @keyup.enter="handleChangePin"
          @input="validatePin"
          label="Confirmar pin nuevo"
          type="password"
          inputmode="numeric"
          v-model="newPin2"
          autocomplete="new-password"
        ></v-text-field>

        <v-row justify="center" class="pt-3">
          <v-btn @click="handleChangePin" color="primary">
            Cambiar
          </v-btn>
        </v-row>

      </v-form>
    </fh-card>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import FhTitle from '@/components/FhTitle'
import FhCard from '@/components/FhCard'
import { mapActions, mapState } from 'vuex'
import { redirect } from '@/utils'

export default {
  name: 'ChangePin',
  components: { FhCard, FhTitle, FhContainer },
  data () {
    return {
      valid: true,
      // Defer validation until first submit attempt
      isSubmit: false,
      currentPin: '',
      currentPinRules: [
        v => !!v || 'Campo obligatorio'
      ],
      newPin: '',
      newPinRules: [
        v => !!v || 'Campo obligatorio'
      ],
      newPin2: '',
      newPinRules2: [
        v => !!v || 'Campo obligatorio',
        v => !this.isSubmit || v === this.newPin || 'Pin deben coincidir'
      ]
    }
  },
  computed: {
    ...mapState('user', [
      'codigoAcceso'
    ])
  },
  methods: {
    ...mapActions('auth', [
      'changePin'
    ]),
    ...mapActions('snackbar', [
      'showSnackbar'
    ]),
    validatePin () {
      // Only validate if the confirmation pin is set
      if (this.newPin2) {
        this.$refs.form.validate()
      }
    },
    async handleChangePin () {
      try {
        this.isSubmit = true
        if (!this.$refs.form.validate()) { return }

        await this.changePin([this.currentPin, this.newPin])
        this.showSnackbar(['Cambio de pin exitoso.', 'success'])

        redirect(this.$route.query, this.$router)
      } catch (e) {
        //
      }
    }
  }
}
</script>

<style scoped>

</style>
